import { Collapse, InputAdornment, MenuItem, TextField, Typography, withStyles } from "@material-ui/core";
import { showMessage } from "app/store/actions";
import withReducer from "app/store/withReducer";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import XAPPButton from "../Button/XAPPButton";
import CustomFieldsEditable from "./CustomFieldsEditable";
import * as Actions from "./Store/Actions/CustomFieldsActions";
import reducer from "./Store/Reducers/CustomFieldsReducer";

const styles = theme => ({
  box: {
    "border": "1px solid " + theme.palette.divider
  },
  contrastBackground: {
    "backgroundColor": theme.palette.background.paper,
  },
});

const TIPOS_CAMPO = [
  {
    "id": "text",
    "label": "Texto"
  },
  {
    "id": "number",
    "label": "Número"
  },
  {
    "id": "date",
    "label": "Data"
  },
  {
    "id": "datetime-local",
    "label": "Data e hora"
  },
  {
    "id": "money",
    "label": "Moeda"
  },
  {
    "id": "select",
    "label": "Seletor"
  },
  {
    "id": "memo",
    "label": "Memorando"
  }
];

const CustomFields = (props) => {

  const { get, xappRouteParams, save, tipo = null, showMessage, reducer, formulario = null, onChange, settings = null } = props;
  const [editable, setEditable] = useState(false);
  const [collapse, setCollapse] = useState([]);

  useEffect(() => {
    if (!_.isNull(tipo) && (_.isNull(reducer.data) || (!_.isNull(reducer.data) && _.isUndefined(reducer.data[tipo])))) {
      get(tipo, xappRouteParams);
    }
  }, []);

  useEffect(() => {
    if (!_.isNull(reducer.data) && !_.isUndefined(reducer.data[tipo])) {
      setGrupoDefaultOpen();
    }
  }, [reducer.data]);

  useEffect(() => {
    if (!_.isNull(reducer.info)) {
      showMessage({
        message: reducer.info,
        variant: "success"
      });
      reducer.info = null;
    }
    if (!_.isNull(reducer.error)) {
      showMessage({
        message: reducer.error,
        variant: "error"
      });
      reducer.error = null;
    }
  }, [reducer.info, reducer.error]);

  function changeCollapse(id) {
    let tmp = [];
    if (collapse.includes(id)) {
      tmp = _.filter(collapse, x => x !== id);
    }
    else {
      tmp = tmp.concat(collapse);
      tmp.push(id);
    }
    setCollapse(tmp);
  }

  function setGrupoDefaultOpen() {
    let tmp = [];
    if (!_.isNull(reducer.data) && !_.isUndefined(reducer.data[tipo]) && !_.isNull(reducer.data[tipo])) {
      _.filter(reducer.data[tipo].grupos, { "disabled": false, "defaultOpen": true }).forEach(grupo => {
        tmp = tmp.concat(grupo.id);
      });
    }

    setCollapse(tmp);
  }

  function getPermissaoEdicao() {
    if (document.location.host.includes("local")) {
      return true;
    }
    if (!_.isNull(settings) && !_.isUndefined(settings.sistemas[xappRouteParams.empresa])) {
      return Boolean(settings.sistemas[xappRouteParams.empresa]?.UI_EDIT_CUSTOM_FIELDS ?? false);
    }
    return false;
  }

  return (
    <React.Fragment>
      {getPermissaoEdicao() &&
        <div className="flex w-full justify-end hidden">
          <XAPPButton
            className=""
            type="icon"
            tooltip={{ title: "Editar campos", placement: "top" }}
            icon={"settings"}
            iconProps=""
            onClick={ev => {
              ev.stopPropagation();
              setEditable(true);
            }}
          />
        </div>
      }
      <React.Fragment>
        {!_.isNull(reducer.data) && !_.isUndefined(reducer.data[tipo]) && !_.isNull(reducer.data[tipo]) && _.filter(reducer.data[tipo].grupos, { "disabled": false }).length > 0 ?
          <React.Fragment>
            {_.orderBy(_.filter(reducer.data[tipo].grupos, { "disabled": false }), "index", "asc").map(grupo => (
              <React.Fragment key={grupo.id}>
                <div className="flex items-center cursor-pointer mb-8" onClick={() => changeCollapse(grupo.id)}>
                  <Typography className="inline font-medium" color="primary" paragraph={false}>{grupo.name}</Typography>
                  <div className="flex-1" />
                  <XAPPButton
                    noHover={true}
                    type="icon"
                    icon={collapse.includes(grupo.id) ? "arrow_up" : "arrow_down"}
                    onClick={() => { }}
                  />
                </div>
                <Collapse in={collapse.includes(grupo.id)} timeout="auto" unmountOnExit className="">
                  {_.filter(reducer.data[tipo].campos, { "grupo": grupo.id, "disabled": false }).length > 0 ?
                    _.orderBy(_.filter(reducer.data[tipo].campos, { "grupo": grupo.id, "disabled": false }), "index", "asc").map(item => (
                      <div className="flex sm:flex-no-wrap flex-wrap" key={item.id}>
                        <CustomField
                          {...item}
                          value={!_.isNull(formulario) ? formulario[item.id] : ""}
                          onChange={onChange}
                        />
                      </div>
                    ))
                    :
                    <div className="flex flex-col flex-1 items-center justify-center p-16">
                      <div className="max-w-512 text-center">
                        <Typography variant="h6" color="textSecondary" className="mb-16">
                          {"Não existem campos personalizados!"}
                        </Typography>
                      </div>
                    </div>
                  }
                </Collapse>
              </React.Fragment>
            ))}
          </React.Fragment>
          :
          <div className="flex flex-col flex-1 items-center justify-center p-16">
            <div className="max-w-512 text-center">
              <Typography variant="h6" color="textSecondary" className="mb-16">
                {"Não existem campos personalizados!"}
              </Typography>
            </div>
          </div>
        }
        <CustomFieldsEditable
          open={editable}
          onClose={setEditable}
          data={!_.isNull(reducer.data) && !_.isUndefined(reducer.data[tipo]) ? reducer.data[tipo] : null}
          save={ev => save(ev, xappRouteParams, tipo)}
          TIPOS_CAMPO={TIPOS_CAMPO}
        />
      </React.Fragment>
    </React.Fragment>
  );
};



function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    save: Actions.save,
    get: Actions.get,
    showMessage: showMessage,
  }, dispatch);
}

function mapStateToProps({ CustomFields, auth }) {
  return {
    reducer: CustomFields,
    settings: auth.user.data.settings,
  };
}

export default withReducer("CustomFields", reducer)(withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(CustomFields)));



const CustomField = props => {
  switch (props.type) {
    case "text":
    case "number":
    case "date":
    case "datetime-local":
      return (
        <TextField
          className="mb-12 w-full"
          label={props.label}
          key={props.id}
          name={props.id}
          value={props.value}
          onChange={props.onChange}
          required={props.required}
          type={props.type}
          variant="outlined"
          fullWidth
          InputLabelProps={{
            shrink: true,
          }}
        />
      );
    case "money":
      return (
        <TextField
          className="mb-12 w-full"
          label={props.label}
          key={props.id}
          name={props.id}
          value={props.value}
          onChange={props.onChange}
          required={props.required}
          type={"number"}
          variant="outlined"
          fullWidth
          InputLabelProps={{
            shrink: true,
          }}
          InputProps={{
            startAdornment: <InputAdornment position="start">R$</InputAdornment>
          }}
        />
      );
    case "select":
      return (
        <TextField
          className="mb-12 w-full"
          label={props.label}
          key={props.id}
          name={props.id}
          value={props.value}
          onChange={props.onChange}
          required={props.required}
          variant="outlined"
          fullWidth
          select
          InputLabelProps={{
            shrink: true,
          }}
        >
          {props.items.map(item => (
            <MenuItem key={item.id} value={item.id}>{item.label}</MenuItem>
          ))}
        </TextField>
      );
    case "memo":
      return (
        <TextField
          className="mb-12 w-full"
          label={props.label}
          key={props.id}
          name={props.id}
          value={props.value}
          onChange={props.onChange}
          required={props.required}
          type={props.type}
          variant="outlined"
          fullWidth
          multiline
          rows={4}
          rowsMax={4}
          InputLabelProps={{
            shrink: true,
          }}
        />
      );
  }
};
